import FullLoader from "components/loader/full-loader";
import { useInvoiceHistory } from "contexts/v1/pages/InvoiceHistoryContext";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import React, { useState } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { deleteRequest } from "services/api";
import Swal from "sweetalert2";
import { URLS } from "utils/constants";
import { formatDateToDayMonthYear } from "utils/dateHelpers";
import { formatPrice } from "utils/utils";
import Transaction from "../invoices/components/transaction";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";

const InvoicesHistoryPage = () => {
    const navigate = useNavigate();
    const { invoices, Pagination, refetch, generateInvoice, id: invoice_id, handleSentWhatsapp, handleSentEmail } = useInvoiceHistory();

    const [transactionCanvas, setTransactionCanvas] = useState({
        show: false,
        data: null,
    });

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await deleteRequest(`/invoice-history/${id}`);

                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: 'Invoice deleted successfully',
                    });
                    refetch();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: 'Failed to delete invoice'
                    });
                }
            }
        });
    };

    if (invoices.pageLoading) {
        return (<FullLoader />);
    }

    return (
        <LayoutDashboard>
            <div className="container-fluid mt-5">
                {invoice_id && (
                    <button className="btn btn-secondary mb-3"
                        onClick={(e) => {
                            navigate(URLS.v1.INVOICES);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        }}>
                        <IconArrowLeft className="me-1" size={16} />
                        Back to Invoice List
                    </button>)}
                <div className="table-container">
                    <div className="search-container mb-3">
                        {/* Search input */}
                        <SearchInput />

                        {/* Create button */}
                        {invoice_id && (
                            <button className="btn btn-primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    generateInvoice(invoice_id).then((response) => {
                                        if (response.success) {
                                            Swal.fire({
                                                icon: "success",
                                                title: "Success!",
                                                text: 'Invoice generated successfully',
                                            });
                                            refetch();
                                        } else {
                                            Swal.fire({
                                                icon: "error",
                                                title: "Oops...",
                                                text: 'Failed to generate invoice'
                                            });
                                        }
                                    });
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }}>Generate Invoice</button>)}
                    </div>

                    {/* Table */}
                    <div className="table">
                        <table className="table table-hover table-vcenter">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Invoice Number</th>
                                    <th>Customer</th>
                                    <th>Recipients</th>
                                    <th>Due Date</th>
                                    <th>Grand Total</th>
                                    <th>Generate at</th>
                                    <th>Status</th>
                                    <th>Total Sent</th>
                                    <th>Last Sent</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            {invoices.data.length > 0 ? (
                                <tbody>
                                    {invoices.data.map((data, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <td>
                                                        {index + 1}
                                                    </td>
                                                    <td><a href={URLS.INVOICES_PUBLIC_VIEW.replace(':invoice_number', data.invoice_number)}>{data.invoice_number}</a></td>
                                                    <td>{data.customer.name}</td>
                                                    <td>
                                                        {data.recipients.map((recipient, index) => (
                                                            <OverlayTrigger
                                                                key={index}
                                                                placement='bottom'
                                                                overlay={
                                                                    <Tooltip id={`tooltip-bottom`}>
                                                                        {recipient.name}
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div
                                                                    key={index}
                                                                    className="avatar-list avatar-list-stacked d-inline cursor-pointer"
                                                                >
                                                                    <span
                                                                        className="avatar avatar-sm rounded-circle"
                                                                        title={recipient.name}
                                                                    >
                                                                        {recipient.name
                                                                            .split(" ")
                                                                            .map((word) => word[0])
                                                                            .join("")}
                                                                    </span>
                                                                </div>
                                                            </OverlayTrigger>
                                                        ))}
                                                    </td>
                                                    <td>{formatDateToDayMonthYear(data.due_date)}</td>
                                                    <td>{formatPrice(data.grand_total)}</td>
                                                    <td>{formatDateToDayMonthYear(data.invoice_date)}</td>
                                                    <td>{data.status}</td>
                                                    <td>{data.sent}</td>
                                                    <td>{data.sent_at ? formatDateToDayMonthYear(data.sent_at) : 'never'}</td>
                                                    <td className="text-end">
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="default" id="dropdownMenuButton1">
                                                                Actions
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setTransactionCanvas({
                                                                        show: true,
                                                                        data: data,
                                                                    });
                                                                }}>Transaction</Dropdown.Item>
                                                                <Dropdown.Item
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleSentWhatsapp(data.invoice_number).then((response) => {
                                                                            if (response.success) {
                                                                                Swal.fire({
                                                                                    icon: "success",
                                                                                    title: "Success!",
                                                                                    text: 'Invoice sent successfully',
                                                                                });
                                                                                refetch();
                                                                            } else {
                                                                                Swal.fire({
                                                                                    icon: "error",
                                                                                    title: "Oops...",
                                                                                    text: 'Failed to send invoice'
                                                                                });
                                                                            }
                                                                        });
                                                                    }}
                                                                >Sent WhatsApp</Dropdown.Item>
                                                                <Dropdown.Item
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        handleSentEmail(data.invoice_number).then((response) => {
                                                                            if (response.success) {
                                                                                Swal.fire({
                                                                                    icon: "success",
                                                                                    title: "Success!",
                                                                                    text: 'Invoice sent successfully',
                                                                                });
                                                                                refetch();
                                                                            } else {
                                                                                Swal.fire({
                                                                                    icon: "error",
                                                                                    title: "Oops...",
                                                                                    text: 'Failed to send invoice'
                                                                                });
                                                                            }
                                                                        });
                                                                    }}
                                                                >Sent Email</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDelete(data.id);
                                                                }}>
                                                                    Remove
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="11" className="text-center">No data available</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="mt-4">
                        {Pagination}
                    </div>

                    {/* Transaction */}
                    <Transaction transactionCanvas={transactionCanvas} setTransactionCanvas={setTransactionCanvas} />
                </div>
            </div>
        </LayoutDashboard>
    )
}

export default InvoicesHistoryPage;

const SearchInput = () => {
    const { handleSearch, filterOptions } = useInvoiceHistory();
    const [search, setSearch] = useState(filterOptions.search || '');

    return (
        <div className="input-icon">
            <input type="text" className="form-control" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={handleSearch} />
            <span className="input-icon-addon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-search"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="10" cy="10" r="7" />
                    <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
            </span>
        </div>
    )
};